import yup from 'core/utils/validators';

const { object, string } = yup;

export const PIN_CODE_CONTRACT_SIGNING_LENGTH = 4;

export const pinCodeContractSingingFormSchema = () =>
  object().shape({
    registration_pin_code: string()
      .min(PIN_CODE_CONTRACT_SIGNING_LENGTH, 'message_length')
      .required('message_required'),
  });
